const KIND_LABELS: Record<string, string> = {
  ConsoleError: 'Console error',
  NetworkFailure: 'Network failure',
  RageClick: 'Rage click',
  DeadClick: 'Dead click',
};

export const formatRynReplayIssueKindLabel = (kind: string): string =>
  KIND_LABELS[kind] ?? kind;
